export default "__VITE_ASSET__CqtFv2UJ__"